import type { Verse } from '@quranjs/api';
import { groupBy } from 'lodash';
import { createFileRoute } from '@tanstack/react-router';
import PageReader from '@/features/reader/components/page-reader';
import { getVersesByPage } from '@/features/reader/lib/queries';
import type { PageReaderContextType } from '@/features/reader/hooks/use-page-reader-context';
import { isPageIdValid } from '@/shared/lib/utils';

export const Route = createFileRoute('/page/$id')({
  staleTime: Number.POSITIVE_INFINITY,

  loader: async ({ params }): Promise<PageReaderContextType> => {
    const { id: pageId } = params;

    if (!isPageIdValid(pageId)) {
      throw new Error(`Invalid page id: ${pageId}`);
    }

    const verses = await getVersesByPage({ data: pageId });
    const versesByChapter = groupBy(verses, (verse: Verse) => verse.chapterId);

    return { versesByChapter, pageId };
  },

  head: ({ params }) => ({
    links: [
      {
        rel: 'stylesheet',
        href: '/fonts/fonts-hafs-v1.css',
      },
      {
        rel: 'preload',
        href: `/fonts/hafs/v1/woff2/p${params.id}.woff2`,
        as: 'font',
        type: 'font/woff2',
        crossOrigin: 'anonymous',
      },
    ],
  }),

  component: PageReaderRoute,
});

function PageReaderRoute() {
  const pageData = Route.useLoaderData();
  return <PageReader {...pageData} />;
}
